import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { DOCUMENT } from '@angular/common';
import { map } from 'rxjs/operators';
import { OrigamiUrlsParams } from '@app/origami-api/constants/origami-urls-params';
import { getQueryParamValue } from '../../../init';
import { AppRouteParts } from '@app/app-routes';

@Injectable({
  providedIn: 'root',
})
export class AuthModuleGuard {
  private readonly authPagesClassName = 'auth-pages';

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  canActivate = () =>
    this.checkAppSession().pipe(
      map((notLoggedIn) => {
        if (notLoggedIn) {
          this.document.body.classList.add(this.authPagesClassName);
        }
        return notLoggedIn;
      }),
    );

  canDeactivate = () => {
    this.document.body.classList.remove(this.authPagesClassName);
    return true;
  };

  canLoad = () => this.checkAppSession();

  canActivateChild = () => this.checkAppSession();

  private checkAppSession() {
    return this.authService.checkSession().pipe(
      map((authInfo) => {
        const notLoggedIn = !authInfo.hasSession || authInfo.registrationMode;
        if (!notLoggedIn) {
          const returnRoute = unescape(unescape(getQueryParamValue(OrigamiUrlsParams.returnRoute) || ''));

          this.router.navigateByUrl(returnRoute || `/${AppRouteParts.Main}`);
          /*
          this.route.queryParams.pipe(take(1)).subscribe((queryParams) => {
            let url = `/${AppRouteParts.Main}`;

            if (queryParams[OrigamiUrlsParams.returnRoute]) {
              const routeParts = (unescape(queryParams[OrigamiUrlsParams.returnRoute]) || '').split('#');
              if (routeParts.length > 1) {
                url = routeParts[1];
              }
            }
          });
          */
        }
        return notLoggedIn;
      }),
    );
  }
}
